import { type ChangeEventHandler, useRef } from 'react';

import { useBulkPhotoUploader } from '@/lib/photoLib';
import type { ScanPartContext } from '@kaiizen/kai-scan-template-system';

type ScanPartPhotoUploadTarget = Parameters<ReturnType<typeof useBulkPhotoUploader>>[1] | null | undefined;

/** Shared file-picker upload seam for any scan part with photo attachments. */
export const useScanPartPhotoUpload = (
  scanPart: ScanPartPhotoUploadTarget,
  scanPartContext: ScanPartContext,
) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const uploadPhotos = useBulkPhotoUploader();

  const onSelectFiles: ChangeEventHandler<HTMLInputElement> = async event => {
    const input = event.currentTarget;
    if (!scanPart) {
      input.value = '';
      return;
    }
    await uploadPhotos(input.files, scanPart, scanPartContext);
    input.value = '';
  };

  return {
    inputRef,
    openFilePicker: () => inputRef.current?.click(),
    onSelectFiles,
  };
};
